module.exports = __webpack_public_path__ + "media/images/紹介割引_500円_1280_480-58f52e759d04df11992fe5b68dabd001.png";